import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { getProfile } from './../../../reducers/identity';
import Loader from './../../loader';
import RoleSelector from './../../roleSelector';
import messages from '../../../text/messages';

const withRole = Page =>
    class extends React.Component {
        static loading = false;

        constructor(props) {
            super(props);

            this.getRoles = this.getRoles.bind(this);
        }

        getRoles(props) {
            let { isAuthenticated, roles, getProfile } = props;
            if (!isAuthenticated || (roles && roles.length > 0) || withRole.loading === true) {
                return;
            }

            withRole.loading = true;
            getProfile(() => (withRole.loading = false));
        }

        componentDidMount() {
            this.getRoles(this.props);
        }

        componentDidUpdate() {
            this.getRoles(this.props);
        }

        render() {
            const { isAuthenticated, roles, role } = this.props;

            // if user is not logged in just return requested page as profile details cannot be obtained.
            if (!isAuthenticated) return <Page {...this.props} />;

            // if user is logged in and roles have been obtained but none is chosen show role selector.
            if (isAuthenticated && roles && !role) return <RoleSelector connected={false} />;

            // if user is logged in roles have been obtained and role is selected render requested page.
            if (isAuthenticated && roles && role) return <Page {...this.props} />;

            // in any other case display loader (as this can only occur while roles have not been loaded at all).
            return <Loader showOverride={true} message={<FormattedMessage {...messages.loadingRoles} />} />;
        }
    };

const mapStateToProps = state => ({
    role: state.identity.role,
    roles: state.identity.roles,
    isAuthenticated: state.identity.isAuthenticated
});
const mapDispatchToProps = dispatch => bindActionCreators({ getProfile: getProfile }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRole);



// WEBPACK FOOTER //
// ./src/components/hoc/role/index.jsx